import {useRef} from 'react';
import {useSelector} from 'react-redux';

import appService from '@/services/appService';
import {selectIsJourneyBadgePending, selectIsJourneyLevelTaskPending} from '@/state/selectors/loyalty';

import useOnReturnToTab from '../useOnReturnToTab';

const useLoyaltyFetchManager = () => {
    const isJourneyBadgePending = useSelector(selectIsJourneyBadgePending);
    const isJourneyLevelTaskPending = useSelector(selectIsJourneyLevelTaskPending);
    const isFetchingRef = useRef(false);

    const checkAndFetch = async () => {
        const shouldFetch = isJourneyBadgePending || isJourneyLevelTaskPending;

        if (!shouldFetch || isFetchingRef.current) return;

        isFetchingRef.current = true;

        await appService.fetchLoyaltyJourneys();

        isFetchingRef.current = false;
    };

    useOnReturnToTab(checkAndFetch);
};

export default useLoyaltyFetchManager;
